module.exports = __webpack_public_path__ + "img/list.a32a4266.svg";